// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget__iframe{width:100%;height:100%;background:transparent}.widget__iframe--edit{pointer-events:none}.widget__iframe .widget-iframe,.widget__iframe .widget-iframe__image{display:flex;margin:0;padding:0}.widget__iframe .widget-iframe{width:100%;height:100%}.widget__iframe .widget-iframe__image{max-width:100%;max-height:100%}.widget__iframe .widget-iframe__label{display:flex;width:100%;padding:8px;justify-content:center;color:#787f87;font-size:18px;font-weight:normal}", ""]);
// Exports
module.exports = exports;
